export default __webpack_public_path__ + "static/media/capcotentin.a64f4adc.svg";